export default __webpack_public_path__ + "static/media/wallet.6abf0735.svg";